import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760f2008"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-newsletter-block-wrap" }
const _hoisted_2 = { class: "sign-newsletter-block" }
const _hoisted_3 = { class: "sign-newsletter-block-title" }
const _hoisted_4 = { class: "sign-newsletter-block-sub-title" }
const _hoisted_5 = { class: "sign-newsletter-block-input" }
const _hoisted_6 = { class: "sign-newsletter-block-button-wrap" }

import {PunpayInput, WrapTitle} from "@/entities";
import {ref} from "vue";
import {UiButton, useLocalizationStore, ValidationMessageModel, validEmail, validText} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'sign-newsletter',
  setup(__props) {

const {translate} = useLocalizationStore();

const validText = ref<validText>();
const validEmail = ref<validEmail>();

const companyName = ref("");
const companyEmail = ref("");
const companyPerson = ref("");
const email = ref();
const person = ref();
const name = ref();
const getValid = () => {
  let validPerson = person.value.getValid() as ValidationMessageModel;
  let validName = name.value.getValid() as ValidationMessageModel;
  let validEmail = email.value.getValid() as ValidationMessageModel;
  if (!validName.IsSuccess || !validEmail.IsSuccess || validPerson.IsSuccess) {
    return false;
  }
};
const onClick = () => {
  console.log("onClick");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('sign_newsletter'),
          size: "regular",
          weight: "700"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("sign_newsletter_text")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(PunpayInput), {
          ref_key: "name",
          ref: name,
          modelValue: companyName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((companyName).value = $event)),
          label: _unref(translate)('company_name'),
          validFunction: validText.value,
          placeholder: ""
        }, null, 8, ["modelValue", "label", "validFunction"]),
        _createVNode(_unref(PunpayInput), {
          ref_key: "person",
          ref: person,
          modelValue: companyPerson.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((companyPerson).value = $event)),
          label: _unref(translate)('company_person'),
          validFunction: validEmail.value,
          placeholder: ""
        }, null, 8, ["modelValue", "label", "validFunction"]),
        _createVNode(_unref(PunpayInput), {
          ref_key: "email",
          ref: email,
          modelValue: companyEmail.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((companyEmail).value = $event)),
          label: _unref(translate)('email'),
          validFunction: validEmail.value,
          placeholder: ""
        }, null, 8, ["modelValue", "label", "validFunction"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(UiButton), {
          class: "sign-newsletter-button",
          color: "#71B92F",
          height: "45",
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)("send")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})